const initialState = {
  cardData: [],
  totalPrice: 0,
  totalCounts: 0,
};

export const formatItemData = (item, quantity) => {
  return {
    id: item.id,
    slug: item.slug,
    name: item.name,
    image: item.image,
    quantity: quantity,
    availableQuantity: item.quantity,
    price: item.price,
    productDetails: item,
  };
};

const cardItems = (state = initialState, { type, data, count }) => {
  switch (type) {
    case "ADD_TO_CART": {
      const cardInfo = { ...state };
      const insertedCount = count ? count : 1;
      const existedItemIndex = cardInfo.cardData.findIndex(
        (item) => item.id === data.id,
      );

      if (existedItemIndex === -1) {
        const addedItem = { ...data, quantity: insertedCount };
        // const addedItem = formatItemData(data, insertedCount);

        cardInfo.cardData = [...cardInfo.cardData, addedItem];
      } else {
        cardInfo.cardData[existedItemIndex].quantity = insertedCount;
      }

      cardInfo.totalCounts = cardInfo.cardData.reduce(
        (acc, curr) => acc + curr.quantity,
        0,
      );
      cardInfo.totalPrice = cardInfo.cardData.reduce(
        (acc, curr) => acc + curr.price * curr.quantity,
        0,
      );

      localStorage.setItem("cart", JSON.stringify({ ...cardInfo }));

      return {
        ...state,
        ...cardInfo,
      };
    }
    case "REMOVE_TO_CART": {
      let removeItem = state.cardData.find((item) => item.id === data.id);
      let newItems = state.cardData.filter((item) => item.id !== data.id);
      let newTotal = state.totalPrice - removeItem.price * removeItem.quantity;
      const newCount = newItems.reduce((acc, curr) => acc + curr.quantity, 0);
      localStorage.setItem("cart", {
        cardData: newItems,
        totalCounts: newCount,
        totalPrice: newTotal,
      });
      return {
        ...state,
        cardData: newItems,
        totalCounts: newCount,
        totalPrice: newTotal,
      };
    }

    case "ADD_QUANTITY": {
      const cardInfo = { ...state };
      const existedItemIndex = cardInfo.cardData.findIndex(
        (item) => item.id === data.id,
      );

      if (existedItemIndex === -1) {
        return {
          ...state,
          ...cardInfo,
        };
      }

      cardInfo.cardData[existedItemIndex].quantity += 1;

      cardInfo.totalCounts = cardInfo.cardData.reduce(
        (acc, curr) => acc + curr.quantity,
        0,
      );
      cardInfo.totalPrice = cardInfo.cardData.reduce(
        (acc, curr) => acc + curr.price * curr.quantity,
        0,
      );

      localStorage.setItem("cart", JSON.stringify({ ...cardInfo }));

      return {
        ...state,
        ...cardInfo,
      };
    }
    case "SUB_QUANTITY": {
      const cardInfo = { ...state };
      const existedItemIndex = cardInfo.cardData.findIndex(
        (item) => item.id === data.id,
      );

      if (existedItemIndex === -1) {
        return {
          ...state,
          ...cardInfo,
        };
      }

      if (cardInfo.cardData[existedItemIndex].quantity === 1) {
        cardInfo.cardData = cardInfo.cardData.filter(
          (item) => item.id !== data.id,
        );
      } else {
        cardInfo.cardData[existedItemIndex].quantity -= 1;
      }

      cardInfo.totalCounts = cardInfo.cardData.reduce(
        (acc, curr) => acc + curr.quantity,
        0,
      );
      cardInfo.totalPrice = cardInfo.cardData.reduce(
        (acc, curr) => acc + curr.price * curr.quantity,
        0,
      );

      localStorage.setItem("cart", JSON.stringify({ ...cardInfo }));

      return {
        ...state,
        ...cardInfo,
      };
    }

    case "CLEAR_CART":
      state = initialState;
      localStorage.setItem("cart", JSON.stringify({ ...state }));
      return state;

    case "UPDATE_CART_PRODUCT_INFO": {
      const cardInfo = { ...state };
      const existedItemIndex = cardInfo.cardData.findIndex(
        (item) => item.id === data.id,
      );

      cardInfo.cardData[existedItemIndex] = formatItemData(
        data,
        cardInfo.cardData[existedItemIndex].quantity,
      );

      localStorage.setItem("cart", JSON.stringify({ ...cardInfo }));
      return {
        ...state,
        ...cardInfo,
      };
    }
    default:
      return state;
  }
};

export default cardItems;
